import React, {FC, ReactElement} from 'react';
import styled from 'styled-components';
import './Button.scss';

export type buttonProps = {
    title: string,
    url: string,
    target: boolean,
    round: string,
    color: string,
    colorHover: string,
    isBold:boolean,
    background: string,
    backgroundHover: string,
    fontSize: string,
    horizontalAlignment: string,
    borderColor: string,
    borderColorHover: string,
    borderWidth: string,
    minWidth: string,
    analyticsClickEvent: string,
    editorPlugins: any | null,
    path: {
        slideIndex: number,
        comboIndex: number,
        setIndex: number,
        groupIndex: number,
        elementIndex: number | null,
    } | null,
    anchorName:string,
    anchorTrigger: string,
    selectedLinkType: string|null
}

type buttonElementProps = {
    round: string,
    color: string,
    colorHover: string,
    background: string,
    backgroundHover: string,
    fontSize: string,
    horizontalAlignment: string,
    borderColor: string,
    borderColorHover: string,
    borderWidth: string,
    minWidth: string,
    isBold:boolean
}


export const ButtonElement = styled.div<buttonElementProps>`
&.buttonElement {
  justify-content: ${props => props.horizontalAlignment || 'inherit'}; 
  @media (max-width:768px) {
    justify-content: center;
  }
  .buttonWrapper {
      background:${props => props.background || 'var(--button-background-color)'};
      border-radius: ${props => props.round ? props.round : 'var(--button-border-radius)'};
      border: ${props => props.borderWidth || '1'}px solid ${props => props.borderColor || 'var(--button-background-color)'};
      min-width: ${props => props.minWidth + '%' || '0'};
      font-size: ${props => props.fontSize + 'px' || 'var(--paragraph-size)'};
      font-weight: ${props => props.isBold ? 'bold' : 'inherit'};
      line-height: 1;
      color:${props => props.color || 'var(--button-text-color)'} !important;
      p, span {
        line-height: 1;
        color:${props => props.color || 'var(--button-text-color)'} !important;
        font-size: ${props => props.fontSize + 'px' || 'var(--paragraph-size)'};
        font-weight: ${props => props.isBold ? 'bold' : 'inherit'};
      }
      &:hover {
        color:${props => props.colorHover || 'var(--button-text-hover-color)'} !important;
        background:${props => props.backgroundHover || 'var(--button-background-hover-color)'};
        border-color: ${props => props.borderColorHover || 'var(--button-background-hover-color)'};
        p, span{
        color:${props => props.colorHover || 'var(--button-text-hover-color)'} !important;
        font-weight: ${props => props.isBold ? 'bold' : 'inherit'};
        }
      }
  }
}
`;


const Button: FC<buttonProps> = ({...props}): ReactElement => {

    const isEditor = props.editorPlugins;

    if (isEditor) {
        const ButtonEditor = require('./BottonEditor').default;
        return <ButtonEditor {...props}/>;
    } else {
        return (
            <ButtonElement className={'buttonElement'} color={props.color} background={props.background}
                           colorHover={props.colorHover} backgroundHover={props.backgroundHover} round={props.round} fontSize={props.fontSize}
                           horizontalAlignment={props.horizontalAlignment} borderWidth={props.borderWidth} borderColor={props.borderColor} minWidth={props.minWidth}
                borderColorHover={props.borderColorHover} isBold={props.isBold} data-analytics-click-event={props.analyticsClickEvent}>

                {((!props.anchorTrigger && !props.selectedLinkType) || props.selectedLinkType !== 'anchor') && <a className={'buttonWrapper'} href={props.url} target={props.target ? '_blank' : '_self'}>{props.title}</a>}
                {((props.anchorTrigger && !props.selectedLinkType) || props.selectedLinkType === 'anchor') && <p className={'buttonWrapper'}>{props.title}</p>}
            </ButtonElement>
        );
    }
};


let settings:any;
let SettingsData;
const environmentLink:any = window.getEnvironmentLink();
try {
    SettingsData = require('../../../settings-data').default;
    // do stuff
} catch (ex) {
    SettingsData = null;
}
if(SettingsData) {
    const settingsClass = new SettingsData();
    const allSettings = settingsClass.getAllSettings();
    settings = [
        [//group
            {
                settingName: 'HorizontalAlignment',
            },
        ],
        [
            {
                settingName: 'Size',
            },
            {
                settingName: 'FontSize',
            },
            {
                settingName: 'Bold',
                property: 'isBold',
            },
            {
                settingName: 'TitleColor',
            },
            {
                settingName: "ButtonBackgroundColor",
                title: "Background Color",
                isShowTitle: false,
                icon: environmentLink + '/assets/images/backgroundColor.svg',
                iconType: 'color',
                iconProperty: 'background',
                hasDrop: true,
                dropWidth: 'big',
                removePadding: true,
                removeArrow: true,
                controls: [
                    {
                        controlName: 'CustomColorsTabs',
                        title: '',
                        defaultValue: '#fff',
                        tabs: [
                            {
                                name: 'default',
                                title:'Default',
                                property: 'background',
                            },
                            {
                                name: 'hover',
                                title:'Hover',
                                property: 'backgroundHover',
                            }
                        ]
                    },
                ],
            },
            {
                settingName: 'BorderColor',
                isShowTitle: false,
                controls: [
                    {
                        controlName: 'CustomColorsTabs',
                        title: '',
                        defaultValue: '#fff',
                        isGradient: false,
                        tabs: [
                            {
                                name: 'default',
                                title:'Default',
                                property: 'borderColor',
                            },
                            {
                                name: 'hover',
                                title:'Hover',
                                property: 'borderColorHover',
                            }
                        ]
                    },
                ],
            },
            {
                settingName: 'BorderWidth',
            },
            {
                settingName: 'ButtonShape',
            },
        ],
        [
            {
                settingName: 'Link',
                controls: [
                    {
                        controlName: 'MultiLinks',
                        title: '',
                        defaultValue: null,
                        tabsInfo: [
                            {
                                name: 'none',
                                title: 'None',
                                controls: []
                            },
                            {
                                name: 'hyperlink',
                                title:'Hyperlink',
                                controls: [
                                    {
                                        controlName: 'InputText',
                                        property: 'url',
                                        title: 'URL',
                                        defaultValue: 'http://',
                                        separateLine: true,
                                        padding: '16px 0',
                                        margin: '0'
                                    },
                                    {
                                        controlName: 'InputText',
                                        property: 'analyticsClickEvent',
                                        title: 'Analytics click event',
                                        defaultValue: null,
                                        separateLine: true,
                                        padding: '16px 0',
                                        margin: '0'
                                    },
                                    {
                                        controlName: 'Toggle',
                                        property: 'target',
                                        title: 'Open in a new tab',
                                        defaultValue: true,
                                        separateLine: false,
                                        padding: '16px 0 18px',
                                        margin: '0'
                                    },
                                ]
                            },
                            {
                                name: 'anchor',
                                title:'Anchor',
                                controls: [
                                    {
                                        controlName: 'AnchorsList',
                                        property: 'anchorTrigger',
                                        title: '',
                                        defaultValue: '',
                                        separateLine: false,
                                        padding: '16px',
                                        margin: '0'
                                    },
                                ]
                            }
                        ]
                    },
                ]
            },
            {
                settingName: 'Anchor',
            }
        ]
    ];
}

const options = [
    {
        name:'link',
        title: 'Link',
        icon: environmentLink + '/assets/images/linkOption.svg',
        action: 'openLink'
    },
    {
        name:'size',
        title: 'Size',
        icon: environmentLink + '/assets/images/Options/size.svg',
        action: 'setActiveWidth',
        settingTitle: 'Size'
    }
]


export default {
    Button,
    settings,
    options,
    label: 'Button'
};


